"use client";
import React, { useState, useRef } from 'react';

export default function FAQArea() {
  const [activeTab, setActiveTab] = useState<number | null>(null);
  const tabRefs = useRef<(HTMLDivElement | null)[]>([]);

  const handleClick = (idx: number) => {
    setActiveTab(activeTab === idx ? null : idx);
  };

  const handleToggle = (idx: number) => {
    return activeTab === idx ? { maxHeight: `${tabRefs.current[idx]?.scrollHeight}px` } : { maxHeight: '0px' };
  };

  const handleActiveClass = (idx: number) => {
    return activeTab === idx ? 'active' : '';
  };

  return (
    <section className="py-16 md:py-20 lg:pb-[90px] lg:pt-[100px]" id={"faq"}>
      <div className="container">
        <div className="section-title text-center space-y-5 lg:space-y-7.5 mb-10 sm:mb-14">
          <span>FAQ</span>
          <h2 className="font-bold">Frequently Asked Questions</h2>
        </div>
        <div className="max-w-[1197px] mx-auto">
          <ul className="faq-accordion flex flex-col gap-y-4 sm:gap-y-[22px]">
            <li className={`accordion-item relative rounded-2xl bg-cover bg-center bg-no-repeat ${handleActiveClass(1)}`}>
              <h3 onClick={() => handleClick(1)} className="py-[22px] pl-5 pr-16 cursor-pointer text-base sm:text-lg lg:text-xl text-[#000D49] rounded-2xl bg-[#005EFF0F] font-bold transition-all duration-300">
                What is PropTechBuzz?
                {/* <span className={`transition-transform duration-300 ${handleRotate(1)}`}>▼</span> */}
              </h3>
              <div ref={(el) => (tabRefs.current[1] = el)} style={handleToggle(1)} className="overflow-hidden max-h-0 duration-500 transition-all">
                <p className="pr-14 sm:pr-5 px-5 pb-4 text-[#AAB7C9] text-sm sm:text-base sm:!leading-[26px] max-w-[490px]">
                  PropTechBuzz is the world&apos;s only digital marketing platform
                  that helps in the business growth of proptech companies
                  around the world.
                </p>
              </div>
            </li>
            <li className={`accordion-item relative rounded-2xl bg-cover bg-center bg-no-repeat ${handleActiveClass(2)}`}>
              <h3 onClick={() => handleClick(2)} className="py-[22px] pl-5 pr-16 cursor-pointer text-base sm:text-lg lg:text-xl text-[#000D49] rounded-2xl bg-[#005EFF0F] font-bold transition-all duration-300">
                Why is PropTechBuzz Disruptive?
                {/* <span className={`transition-transform duration-300 ${handleRotate(2)}`}>▼</span> */}
              </h3>
              <div ref={(el) => (tabRefs.current[2] = el)} style={handleToggle(2)} className="overflow-hidden max-h-0 duration-500 transition-all">
                <p className="pr-14 sm:pr-5 px-5 pb-4 text-[#AAB7C9] text-sm sm:text-base sm:!leading-[26px]">
                  1. Because no one has a better pulse of the industry than
                  us.We are laser focussed on global proptech industry. No one
                  has more granularity and segmented focus of the industry
                  than us. <br />2. By running campaigns for dozens of
                  proptech and construction tech companies in this industry,
                  we have acquired data and insights that gives us an edge
                  over any other general purpose agencies. As a result, no one
                  can power sales, marketing and revenue operations in global
                  proptech better than us. <br />3. We are also the world&apos;s
                  only platform that hosts over 10K proptech and construction
                  tech products and community of over 10,000 members . Hence,
                  we have built exhaustive buyers database of all kinds of
                  segments: Assetowners, real estate developers, mortgage
                  brokers, agents and brokers, you name it. <br />4. Our
                  platform is also disruptive because it combines the power of
                  media, products, leadership and community.
                </p>
              </div>
            </li>
            <li className={`accordion-item relative rounded-2xl bg-cover bg-center bg-no-repeat ${handleActiveClass(3)}`}>
              <h3 onClick={() => handleClick(3)} className="py-[22px] pl-5 pr-16 cursor-pointer text-base sm:text-lg lg:text-xl text-[#000D49] rounded-2xl bg-[#005EFF0F] font-bold transition-all duration-300">
                What Products Does PropTech Promotes?
                {/* <span className={`transition-transform duration-300 ${handleRotate(3)}`}>▼</span> */}
              </h3>
              <div ref={(el) => (tabRefs.current[3] = el)} style={handleToggle(3)} className="overflow-hidden max-h-0 duration-500 transition-all">
                <p className="pr-14 sm:pr-5 px-5 pb-4 text-[#AAB7C9] text-sm sm:text-base sm:!leading-[26px] max-w-[490px]">
                  Software products powering real estate, construction, and
                  retail industry.
                </p>
              </div>
            </li>
            <li className={`accordion-item relative rounded-2xl bg-cover bg-center bg-no-repeat ${handleActiveClass(4)}`}>
              <h3 onClick={() => handleClick(4)} className="py-[22px] pl-5 pr-16 cursor-pointer text-base sm:text-lg lg:text-xl text-[#000D49] rounded-2xl bg-[#005EFF0F] font-bold transition-all duration-300">
                What Are PropTechBuzz&apos;s Premium Offerings?
                {/* <span className={`transition-transform duration-300 ${handleRotate(4)}`}>▼</span> */}
              </h3>
              <div ref={(el) => (tabRefs.current[4] = el)} style={handleToggle(4)} className="overflow-hidden max-h-0 duration-500 transition-all">
                <p className="pr-14 sm:pr-5 px-5 pb-4 text-[#AAB7C9] text-sm sm:text-base sm:!leading-[26px] max-w-[490px]">
                  We offer two key services: <br />
                  1. Growth marketing <br />
                  2. Brand awareness marketing
                </p>
              </div>
            </li>
            <li className={`accordion-item relative rounded-2xl bg-cover bg-center bg-no-repeat ${handleActiveClass(5)}`}>
            </li>
          </ul>
        </div>
      </div>
    </section>
  );
}
